import type { TypedArray } from 'three';

// 斐波那契数列函数
export const fibonacci = (n: number): number => {
  if (n <= 1) return n;
  return fibonacci(n - 1) + fibonacci(n - 2);
};

// 归一化数组
export const normalize = (array: Array<number> | TypedArray, normalization = 1): Array<number> => {
  let min = array[0];
  let max = array[0];

  for (let i = 1; i < array.length; i++) {
    if (array[i] < min) {
      min = array[i];
    }

    if (array[i] > max) {
      max = array[i];
    }
  }
  if (max === min) {
    return new Array(array.length).fill(normalization);
  }
  return new Array(array.length).fill(0).map((_, i) => ((array[i] - min) / (max - min)) * normalization);
};

/**
 * 计算两个点之间的水平距离和空间距离
 * @param x1 第一个点的 x 值
 * @param y1 第一个点的 y 值
 * @param z1 第一个点的 z 值
 * @param x2 第二个点的 x 值
 * @param y2 第二个点的 y 值
 * @param z2 第二个点的 z 值
 * @returns horizontalDistance xy 方向上的距离,近似到一位小数
 * @returns distance xyz 方向上的距离,近似到一位小数
 */
export const distanceToPoints = (x1: number, y1: number, z1: number, x2: number, y2: number, z2: number) => {
  const distance = Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2 + (z1 - z2) ** 2);
  return Math.round(distance * 10) / 10;
};

/**
 * 将某个值限定在范围内
 * @param value
 * @param min
 * @param max
 * @returns
 */
export const clampNumber = (value: number, min: number, max: number) => {
  return Math.max(min, Math.min(max, value));
};

/**
 * 保留指定位小数
 * @param x 浮点数
 * @param n 整数，保留的位数
 * @returns
 */
export const roundDecimals = (x: number, n = 2) => {
  const op = Math.pow(10, n);
  return Math.round(x * op) / op;
};

let _tem = 0;
/**
 * 交换数组中两个元素的位置。会修改原数组
 * @param array 数组
 * @param index1 和 index2 交换的位置 index1
 * @param index2 和 index1 交换的位置 index2
 */
export const exchangeArrayItem = (array: number[], index1: number, index2: number) => {
  _tem = array[index1];
  array[index1] = array[index2];
  array[index2] = _tem;
};

/**
 * 按指定大小的数组块反转整个数组。会修改原数组
 * @param array 需要操作的原数组
 * @param size 数组块的大小
 * @returns 返回按指定大小的数组块反转后的数组
 */
export const reverseArrayChunks = (array: number[], size: number) => {
  if (array.length % size !== 0) return array;

  const num = array.length / size;
  const count = num >> 1;

  for (let left = 0, len = array.length; left < count * size; left = left + size) {
    const right = len - left - size;
    for (let j = 0; j < size; j++) {
      exchangeArrayItem(array, left + j, right + j);
    }
  }

  return array;
};
